import { createContext, useReducer } from "react";
import * as types from "./types";

const initialState = {
  loading: false,
  notificationsList: [],
  notificationsCount: 0,
  allRead: false,
};

const notificationsReducer = (state, action) => {
  if (action.type === types.GET_NOTIFICATIONS_LISTING) {
    return {
      ...state,
      notificationsList: action.payload,
    };
  } else if (action.type === types.SET_NOTIFICATIONS_COUNT) {
    return {
      ...state,
      notificationsCount: action.payload,
    };
  } else if (action.type === types.SET_ALL_READ) {
    return {
      ...state,
      allRead: action.payload,
    };
  } else if (action.type === types.SET_NOTIFICATIONS_LOADING) {
    return {
      ...state,
      loading: action.payload,
    }
  } else {
    return state;
  }
};

export const NotificationsContext = createContext(initialState);

const NotificationsProvider = ({ children }) => {
  const [notificationState, notificationDispatch] = useReducer(
    notificationsReducer,
    initialState
  );

  return (
    <NotificationsContext.Provider
      value={[notificationState, notificationDispatch]}
    >
      {children}
    </NotificationsContext.Provider>
  );
};

export default NotificationsProvider;
